import { Box, Chip, FormControlLabel, Switch, Typography } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { IPropsBusinessPage } from '../Business';
import { CrudListPage } from '../../../shared/components/SconApp/crud/CrudListPage';
import { BusinessProductsRegister } from './BusinessProduct';
import { productService, businessService, feedback } from '../../../shared/services';

export const BusinessProducts: React.FC<IPropsBusinessPage> = ({ business, refetch }) => {
  const [useGross, setUseGross] = useState(business.productCommissionUsesGrossRevenue ?? true);

  const { mutate: updateUseGross } = useMutation(
    () => businessService.update({ ...business, productCommissionUsesGrossRevenue: useGross }),
    { onSuccess: () => feedback('Configuração salva', 'success'), onError: (e: Error) => feedback(e.message, 'error') }
  );

  return (
    <CrudListPage
      items={business.products ?? []}
      businessId={business.id!}
      entityName='product'
      removeApi={(id) => productService.remove(id)}
      onRefetch={refetch}
      RegisterForm={BusinessProductsRegister}
      topContent={
        <FormControlLabel
          control={
            <Switch
              checked={useGross}
              onChange={(e) => {
                setUseGross(e.target.checked);
                setTimeout(() => updateUseGross(), 100);
              }}
            />
          }
          label={
            <Box>
              <Typography variant='body2'>Comissão sobre valor bruto</Typography>
              <Typography variant='caption' color='text.secondary'>
                Quando ativado, a comissão dos produtos ignora a taxa do cartão
              </Typography>
            </Box>
          }
        />
      }
      mapToItem={(item) => ({
        id: item.id || 0,
        description: `${item.description} - R$${item.amount}`,
        endAdornment: (
          <Chip
            label={item.isActive ? 'Ativo' : 'Inativo'}
            size='small'
            color={item.isActive ? 'success' : 'default'}
            variant={item.isActive ? 'filled' : 'outlined'}
          />
        ),
      })}
    />
  );
};
